import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';

const isTruthy = val => val !== null && val !== undefined;

@Module({
    namespaced: true,
})
export default class Auth extends VuexModule {

    _id = null
    email = null
    isActive = false
    otpVerified = false
    permissions = {}
    phone = ''
    securityQA = {}
    userName = ''
    catalogInfo = [];
    userRole = ''
    tenant = ''

    @Mutation
    setLoginUser(data) {
        Object.assign(this, data);
    }

    @Mutation
    setCatalogInfo(data) {
        this.catalogInfo = data;
    }

    @Mutation
    setUserRoleInfo(data) {
        this.userRole = data;
    }



    @Action({ commit: 'setLoginUser' })
    loginUser(data) {
        return data
    }

    @Action({ commit: 'setCatalogInfo' })
    setCatalog(data) {
        return data
    }

    @Action({ commit: 'setUserRoleInfo' })
    setUserRole(data) {
        return data
    }

    get isAuthed() {
        return isTruthy(this.userName) && isTruthy(this._id);
    }

    get getloginUser() {
        return this;
    }

    get getUserCatalog() {
        return this.catalogInfo;
    }

    get getUserID() {
        return this._id;
    }

    get getUserRole() {
        return this.userRole;
    }

    get getUserPermissions() {
        return this.permissions;
    }

    get getTenant() {
      return this.tenant;
    }

}
